var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIconGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0005 15.9791V18.3877C20.0014 18.6113 19.9555 18.8326 19.8657 19.0375C19.776 19.2424 19.6443 19.4263 19.4792 19.5775C19.3141 19.7286 19.1192 19.8437 18.907 19.9154C18.6948 19.987 18.4699 20.0136 18.2467 19.9935C15.7712 19.725 13.3933 18.8808 11.3041 17.5286C9.36035 16.2959 7.71239 14.6512 6.47725 12.7113C5.11766 10.6168 4.27157 8.23206 4.00751 5.75036C3.9874 5.52834 4.01384 5.30457 4.08514 5.0933C4.15644 4.88203 4.27103 4.6879 4.42162 4.52325C4.57222 4.35861 4.75551 4.22706 4.95984 4.13699C5.16416 4.04691 5.38504 4.00029 5.60841 4.00008H8.02184C8.41226 3.99624 8.79075 4.13422 9.08677 4.3883C9.3828 4.64237 9.57615 4.99521 9.63079 5.38103C9.73265 6.15185 9.92157 6.9087 10.1939 7.63713C10.3022 7.9245 10.3256 8.23682 10.2614 8.53707C10.1973 8.83732 10.0482 9.11292 9.83191 9.33121L8.81023 10.3509C9.95544 12.3609 11.623 14.0252 13.6371 15.1682L14.6588 14.1485C14.8775 13.9326 15.1536 13.7839 15.4545 13.7198C15.7553 13.6558 16.0683 13.6792 16.3562 13.7872C17.0861 14.059 17.8444 14.2476 18.6168 14.3492C19.0076 14.4042 19.3645 14.6007 19.6196 14.9012C19.8747 15.2017 20.0103 15.5853 20.0005 15.9791Z",
    stroke: "url(#paint0_linear_2703_26327)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2703_26327",
    x1: 2.96098,
    y1: 12,
    x2: 18.9955,
    y2: 20.3755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconGradient);
export default __webpack_public_path__ + "static/media/phone-icon-gradient.9ebff29e054a1f1ca4efbd5d962a7e48.svg";
export { ForwardRef as ReactComponent };